<template>
    <div id="admin-welcome">
        <span class="admin-welcome__wave" role="img" aria-label="Waving hand">👋</span>
        <h4>Welcome to Zyno<span>Suite</span> Admin</h4>
        <p class="admin-welcome__hint admin-welcome__hint--wide">Choose an item from the left to get started.</p>
        <p class="admin-welcome__hint admin-welcome__hint--narrow">Open the menu to choose an item to get started.</p>
        <p>If you need any help, <a href="#" @click.prevent="openSupport">click here</a> to open a support ticket and we'll be in touch shortly.</p>
    </div>
</template>

<script lang="ts" setup>
import { openHelp } from '@/shared/helpers/help.helpers';

function openSupport() {
    // Same path the sidebar's "Help" util-row uses — opens the support help drawer.
    openHelp();
}
</script>

<style scoped>
@reference '#tw.css';

#admin-welcome {
    @apply flex-1 flex flex-col items-center justify-center gap-8 px-6 text-center;

    * {
        @apply text-ink-3;
    }

    h4 {
        @apply font-extralight;

        span {
            @apply font-bold;
        }
    }

    a {
        @apply text-accent hover:text-accent-ink;
    }
}

/* The nav is the always-visible left sidebar on desktop, but a menu drawer on
   mobile — so the hint copy swaps accordingly. */
.admin-welcome__hint--narrow {
    display: none;
}

@media (max-width: 768px) {
    .admin-welcome__hint--wide {
        display: none;
    }

    .admin-welcome__hint--narrow {
        display: block;
    }
}

.admin-welcome__wave {
    @apply text-6xl;
    line-height: 1;
    transform-origin: 70% 80%;
    animation: wave 2.5s ease-in-out infinite;
}

@keyframes wave {
    0% {
        transform: rotate(0deg);
    }
    10% {
        transform: rotate(15deg);
    }
    20% {
        transform: rotate(-15deg);
    }
    30% {
        transform: rotate(15deg);
    }
    40% {
        transform: rotate(-15deg);
    }
    50% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(0deg);
    }
}
</style>
